import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage';
import { HttpModule, Http  } from '@angular/http';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { MyApp } from './app.component';
import { IndexPage } from '../pages/index/index';
import { UsuarioProvider } from '../providers/usuario/usuario';
import { VehiculoProvider } from '../providers/vehiculo/vehiculo';
import { CotizarProvider } from '../providers/cotizar/cotizar';
import { EdsProvider } from '../providers/eds/eds';

@NgModule({
  declarations: [
    MyApp,
    IndexPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    HttpModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    IndexPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    UsuarioProvider,
    VehiculoProvider,
    ScreenOrientation,
    CotizarProvider,
    EdsProvider,
    InAppBrowser
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts